module.exports = __webpack_public_path__ + "img/ren-img.d2d10e81.png";